import api from './api';

export const itinerariesService = {
  // Get all itineraries
  getAll: async (params = {}) => {
    const response = await api.get('/itineraries', { params });
    return response.data;
  },

  // Get single itinerary
  getById: async (id) => {
    const response = await api.get(`/itineraries/${id}`);
    return response.data;
  },

  // Update itinerary
  update: async (id, itineraryData) => {
    const response = await api.put(`/itineraries/${id}`, itineraryData);
    return response.data;
  },

  // Add payment to itinerary
  addPayment: async (itineraryId, paymentData) => {
    const response = await api.post(`/itineraries/${itineraryId}/payments`, paymentData);
    return response.data;
  },

  // Get itinerary payments
  getPayments: async (itineraryId) => {
    const response = await api.get(`/itineraries/${itineraryId}/payments`);
    return response.data;
  },

  // Send update to client
  sendUpdate: async (itineraryId, updateData) => {
    const response = await api.post(`/itineraries/${itineraryId}/send-update`, updateData);
    return response.data;
  }
};
